import React from 'react'

const Swatch = ({ color }) => (
  <div className='dib mr2 w1 h1' style={{ background: color }} />
)

export default Swatch
